import store from "./store";
import routes from "./routes";

export default {
  install(Vue, { store: rootStore, router }) {
    router.addRoutes(routes);
    rootStore.registerModule("settings", store);
  }
};
